<template>
  <Card>
    <template slot="header">Generate Report</template>
    <v-layout justify-center>
      <v-menu
        :nudge-right="30"
        transition="scale-transition"
        offset-y
        min-width="290px"
        @input="update()"
      >
        <v-text-field
          slot="activator"
          v-model="dateRange.startDate"
          label="Start Date"
          prepend-icon="event"
          readonly
        />
        <v-date-picker v-model="dateRange.startDate"/>
      </v-menu>
      <v-menu
        :nudge-right="30"
        transition="scale-transition"
        offset-y
        min-width="290px"
        @input="update()"
      >
        <v-text-field
          slot="activator"
          v-model="dateRange.endDate"
          label="End Date"
          prepend-icon="event"
          readonly
        />
        <v-date-picker v-model="dateRange.endDate"/>
      </v-menu>
    </v-layout>
    <v-layout>
      <v-flex class="xs4 offset-xs4">
        <v-select
          v-model="report"
          :items="reports"
          label="Select Report"
        />
        <v-btn
          v-if="report"
          :loading="loading"
          @click="generate()"
        >Generate</v-btn>
        <template v-if="csv == report">
          <CSVDownload
            v-if="generatedReport.length"
            :data="generatedReport"
          />
          <span
            v-else
            class="red--text"
          >
            No Data in that range.
          </span>
        </template>
      </v-flex>
    </v-layout>
  </Card>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      report: null,
      reports: [
        { text: 'CUPS Utilization', value: 'cupsUtilization' },
        { text: 'Camping Detail', value: 'campingDetail' },
        { text: 'Site Occupancy', value: 'siteOccupancy' },
        { text: 'Parking Detail', value: 'parkingDetail' }
      ],
      csv: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      dateRange: 'reports/dateRange',
      generatedReport: 'reports/generatedReport'
    })
  },
  methods: {
    ...mapActions({
      updateDateRange: 'reports/updateDateRange',
      getGeneratedReport: 'reports/getGeneratedReport'
    }),
    update () {
      this.updateDateRange(this.dateRange).then(() => {
        this.csv = false
      })
    },
    generate () {
      this.loading = true
      let payload = { report: this.report }
      this.getGeneratedReport(payload).then(() => {
        this.loading = false
        this.csv = this.report
      })
    }
  }
}
</script>
